import { useLocalizedText } from '../hooks/useLocalizedText';

/**
 * @param {{ value?: { en?: string, ar?: string } | string, className?: string }} props
 */
export default function LocalizedText({ value, className }) {
  const text = useLocalizedText(value);
  return <span className={className}>{text}</span>;
}
